interface PackageComponent {
	icon: string;
	contentKey: string;
	contentKeyShort?: string;  // Optional shorter version for NL/UK
}

interface PackageComposition {
	components: PackageComponent[];
}

const packageCompositionConfig: Record<string, PackageComposition> = {
	HS: {
		components: [
			{ icon: 'home', contentKey: 'packages_home' }
		]
	},
	PF: {
		components: [
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' }
		]
	},
	PFCS: {
		components: [
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' }
		]
	},
	PFP: {
		components: [
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_materiel' }
		]
	},
	PFPF: {
		components: [
			{ icon: 'flight', contentKey: 'packages_flight', contentKeyShort: 'packages_flight' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_materiel_short' }
		]
	},
	PFF: {
		components: [
			{ icon: 'flight', contentKey: 'packages_flight', contentKeyShort: 'packages_flight' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
		]
	},
	HF: {
		components: [
			{ icon: 'flight', contentKey: 'packages_flight', contentKeyShort: 'packages_flight' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
		]
	},
	HTT: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home_short' },
		]		
	},
	HTTF: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home_short' },
		]
	},
	PFPCS: {
		components: [
			{ icon: 'home', contentKey: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_materiel' }
		]
	},
	PFTT: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' }
		]
	},
	PFTTF: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
		]
	},
	PFPTT: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_materiel_short' }
		]
	},
	PFPTTF: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_materiel_short' }
		]
	},
	PFTTNL: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
		]
	},
	PFTTUK: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
		]
	},
	PFPTTNL: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_materiel_short' }
		]
	},
	PFPTTUK: {
		components: [
			{ icon: 'train', contentKey: 'packages_train' },
			{ icon: 'home', contentKey: 'packages_home', contentKeyShort: 'packages_home_short' },
			{ icon: 'skipass', contentKey: 'packages_skipass' },
			{ icon: 'materiel', contentKey: 'packages_materiel_short' }
		]
	},
	PMA: {
		components: [
			{ icon: 'home', contentKey: 'packages_home' },
			{ icon: 'skipass', contentKey: 'planningSummary_options_passMultiActivities' }
		]
	}
};

export default packageCompositionConfig;
export type { PackageComponent, PackageComposition }; 